var map = {
	"./index.js": "FyoP",
	"./superset.js": "ErFR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZAur";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules/dashboard nonrecursive \.js$
// module id = ZAur
// module chunks = 5